// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2hRPT","selects":"Documents_selects__3KG5v"};